import { Component } from '@angular/core';

// Store
import { Store } from '@ngrx/store';
import { RootReducerState } from '../store';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

  constructor(private store: Store<RootReducerState>) { }

  ngOnInit() {
    this.store.select('layout').subscribe((data) => {
      document.documentElement.setAttribute('data-layout', data.LAYOUT_THEME);
      document.documentElement.setAttribute('data-bs-theme', data.LAYOUT_MODE);
      document.documentElement.setAttribute('data-layout-width', data.LAYOUT_WIDTH);
      document.documentElement.setAttribute('data-card-layout', data.CARD_LAYOUT);
      document.documentElement.setAttribute('data-topbar-image', data.TOPBAR_IMAGE);
      document.documentElement.setAttribute('data-layout-position', data.LAYOUT_POSITION);
      document.documentElement.setAttribute('data-topbar', data.TOPBAR);
      document.documentElement.setAttribute('data-preloader', data.DATA_PRELOADER)
      document.documentElement.setAttribute('data-sidebar-size', data.SIDEBAR_SIZE)
      document.documentElement.setAttribute('data-sidebar', data.SIDEBAR_COLOR)
    })
  }
}
